import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SpotNameInput from '../../common/inputs/customs/spot-name-input';
import CategoriesInput from '../../common/inputs/customs/categories-input';
import PlatformInput from '../../common/inputs/customs/platform-input';
import UrlInput from '../../common/inputs/customs/url-input';
import EnableRichSayControl from '../enable-rich-say-control';
import EnableConversationStaleness from '../enable-conversation-staleness';
import GifAnimation from '../gif-animation';
import Emoji from '../emoji';
import LanguageInterface from '../../common/inputs/interface-language';
import SortBy from '../../common/inputs/customs/sort-by';
import MaxRepliesDepth from '../../common/inputs/customs/max-replies-depth';
import AccessTokens from '../../common/inputs/customs/access-tokens';
import AdsTextsGenerator from '../../common/inputs/customs/ads-texts-generator';
import SetPitcStaleness from '../set-pitc-staleness';
import ConversationSurveyToggle from './conversation-survey/conversation-survey-toggle';
import LogoUpload from '../LogoUpload';
import { FloatingEngagingUnitSettings } from './floating-action-unit/FloatinActionUnitSettings';
import { TenantConfigLoader } from '../../../tenant-config/TenantConfigLoader';
import { settingsGeneralConfigMap } from '../../../tenant-config/tenantConfigConstants';

class General extends Component {
  render() {
    var { currentUser, spot } = this.props;
    const isSuperAdmin = currentUser.isSuperAdmin;
    let spotId = spot.id;
    let spotName = spot.name;

    const gifAnimation = (
      <GifAnimation
        spotId={spotId}
        gifLevel={spot.gifAnimationLevel}
        gifSpotPolicy={spot.commentsContainingGifs}
      />
    );

    const emojiKeyboard = <Emoji spotId={spotId} value={spot.emojiKeyboardEnabled} />;

    return (
      <div className="preferences-general sidebar-layout">
        <TenantConfigLoader adminConfig={settingsGeneralConfigMap} />
        <div className="main-content">
          <div className="fields">
            <AdsTextsGenerator spotId={spotId} />
            {spot.websiteUrl ? <UrlInput autoSave spotId={spotId} value={spot.websiteUrl} /> : null}
            <SpotNameInput autoSave spotId={spotId} value={spot.name} />
            <CategoriesInput
              autoSave
              spotId={spotId}
              categoryId={spot.categoryId}
              subCategoryId={spot.subCategoryId}
              edit
            />
            <LogoUpload />
            <PlatformInput autoSave spotId={spotId} value={spot.platform} />
            <LanguageInterface spotId={spotId} value={spot.mainLanguage} />
            <SortBy spotId={spotId} value={spot.sortBy} />
            <MaxRepliesDepth spotId={spotId} maxRepliesDepth={spot.maxRepliesDepth} />
            <EnableRichSayControl spotId={spotId} value={spot.enableRichSayControl} />
            {gifAnimation}
            {emojiKeyboard}
            <FloatingEngagingUnitSettings />
            <AccessTokens spotId={spotId} />
            {isSuperAdmin && <ConversationSurveyToggle spotId={spotId} spotName={spotName} />}
            <EnableConversationStaleness />
            <SetPitcStaleness />
          </div>
        </div>
      </div>
    );
  }
}

General.displayName = 'General';

General.propTypes = {
  spot: PropTypes.object,
  currentUser: PropTypes.object
};

export default General;
